import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledHeading = styled(Type)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
  padding: ${({ theme }) => theme.space.md} 0 ${({ theme }) => theme.space.md};
  margin: 0 0 ${({ theme }) => theme.space.md};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 0 ${({ theme }) => theme.space.md};
  }
  @media print {
    font-size: ${({ theme }) => theme.font.size.md};
    border-bottom: none;
    padding: 0;
    margin: ${({ theme }) => theme.space.md} 0 ${({ theme }) => theme.space.md};
  }
`;

export const SectionHeadingForPrint = styled(Type)`
  display: none;
  @media print {
    display: block;
    margin: ${({ theme }) => theme.space.md} 0 0;
  }
`;
